// src/utils/adminNotify.js
import { sendNotificationToAdmin } from "./../services/notificationServices";

export const notifyAdmin = async (message) => {
  const token = localStorage.getItem("token");
  if (!token) return; // pas connecté / pas de notif possible

  try {
    await sendNotificationToAdmin(message, token);
  } catch (e) {
    console.error("Erreur notification admin :", e);
  }
};
